import React from 'react';

const Footer: React.FC = () => (
  <footer className="border-t border-netflix-gray/60 dark:border-light-border bg-netflix-black/95 dark:bg-light-bg">
    <div className="max-w-7xl mx-auto px-6 py-6 text-center">
      <p className="text-sm text-netflix-light-gray dark:text-light-muted">
        © 2026 Cyrus Portfolio. All Rights Reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
